import React from 'react'
import { Box } from '@mui/material'

import {
  formatFillRateProductSummaryDifference
} from '../helpers/fillRateProductDifferencesFormatters'
import { getFillRateProductDifferenceTotalSx } from '../style/fillRateProductDifferencesStyles'

const FillRateProductDifferenceTotalValue = ({ value }) => {
  return (
    <Box component="span" sx={getFillRateProductDifferenceTotalSx(value)}>
      {formatFillRateProductSummaryDifference(value)}
    </Box>
  )
}

export default FillRateProductDifferenceTotalValue
